import axios from 'axios';

import { HighlightsInfoTextCardResponse } from '../types';
import {
  interceptorRequestAuthenticationHeaders,
  interceptorResponseErrors,
  interceptorResponseTransformData,
} from '../../../services/iclinic/interceptors';

export const highlightsInfoApi = axios.create({
  baseURL: process.env.ICLINIC_PEP_API_URL,
});

highlightsInfoApi.interceptors.request.use(
  interceptorRequestAuthenticationHeaders,
);
highlightsInfoApi.interceptors.response.use(
  interceptorResponseTransformData,
  interceptorResponseErrors,
);

export const getHighlightsInfos = (
  patientId: string,
): Promise<{
  cards: HighlightsInfoTextCardResponse[];
}> => highlightsInfoApi.get(`/api/v1/highlight_info/${patientId}`);

export const saveHighlightsInfo = (
  highlightsInfo: HighlightsInfoTextCardResponse,
): Promise<HighlightsInfoTextCardResponse> =>
  highlightsInfoApi.post(`/api/v1/highlight_info/`, highlightsInfo);
